import { createActionGroup, emptyProps } from '@ngrx/store';

export const forbiddenPageActions = createActionGroup({
  source: 'Forbidden Page',
  events: {
    Opened: emptyProps(),
  },
});
